
import React from "react";
import { 
  BarChart, Bell, Building, Calendar, Download,
  FileText, MessageSquare, Mail, PenTool, 
  Settings, UserPlus, Users, Twitter, LayoutGrid,
  Newspaper, FileCheck, Megaphone
} from "lucide-react";

export const getIcon = (iconName: string): React.ElementType => {
  const icons: { [key: string]: React.ElementType } = {
    BarChart,
    Bell,
    Building,
    Calendar,
    Download,
    FileText,
    MessageSquare,
    Mail,
    PenTool,
    Settings,
    UserPlus,
    Users,
    Twitter,
    LayoutGrid,
    Newspaper,
    FileCheck,
    Megaphone
  };
  return icons[iconName] || Calendar;
};
